<template>
  <div>
    <div class="carousel__main">
      <div class="carousel__image">
        <div class="image__slide">
          <img src="images/slider.png" alt="" />
        </div>
        <div class="carousel__content-text">
          <div class="carousel__text">
            <h1>NSIA e-Commerce</h1>
            <div class="carousel__text-intro">
              Souscrivez désormais aux différentes offres de NSIA sans vous
              déplacer
            </div>
          </div>
          <div class="centering">
            <button class="btn btn-secondary">Souscrire à une offre</button>
          </div>
        </div>
      </div>
    </div>

    <section class="body--main">
      <div class="container-fluid">
        <div class="container">
          <div class="information__section">
            <div class="information__section--header">
              Choisissez votre fil, nous tissons votre avenir
            </div>
            <div class="information__section--description">
              Découvrez nos produits
            </div>
          </div>
        </div>
        <div class="product__section">
          <div class="product__section-p">
            <div
              class="product__section--item"
              style="
                background: url('images/nsia-auto.png') no-repeat center;
                background-size: cover;
              "
            >
              <div class="step">
                <div class="product__section--item_title">Assurance Auto</div>
                <div class="product__section--item_desc">
                  Couvrez les dommages matériels et / ou corporels que votre
                  véhicule peut occasionner à autrui et à vous même
                </div>
                <a
                  :href="$routing('assurance-automobile')"
                  class="btn btn-secondary"
                  >Soumettre</a
                >
              </div>
            </div>
          </div>
          <div class="product__section-p">
            <div
              class="product__section--item"
              style="
                background: url('images/nsia-apefa.png') no-repeat center;
                background-size: cover;
              "
            >
              <div class="step">
                <div class="product__section--item_title">
                  Assurance multirisque habitation “APEFA”
                </div>
                <div class="product__section--item_desc">
                  Protégez votre logement et vos biens mobiliers des domages
                  causés par un incendie, un dégât des eaux ou une explosion.
                </div>
                <a
                  :href="$routing('assurance-habitation')"
                  class="btn btn-secondary"
                  >Soumettre</a
                >
              </div>
            </div>
          </div>
          <div class="product__section-p">
            <div
              class="product__section--item"
              style="
                background: url('images/voyage.png') no-repeat center;
                background-size: cover;
              "
            >
              <div class="step">
                <div class="product__section--item_title">Assurance Voyage</div>
                <div class="product__section--item_desc">
                  Contre la survenance d’un certain nombre d’évènements à
                  l’occasion et au cours de son voyage hors du territoire
                  togolais
                </div>
                <a
                  :href="$routing('assurance-voyage')"
                  class="btn btn-secondary"
                  >Soumettre</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section__how_it-work">
        <div class="heading__text">
          <span>Comment ça marche ?</span>
        </div>
        <div class="work__bloc">
          <div class="work__bloc--item">
            <div class="work__bloc--item_icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 50.0725C0 22.4583 22.3858 0.0725098 50 0.0725098V0.0725098C77.6142 0.0725098 100 22.4583 100 50.0725V50.0725C100 77.6867 77.6142 100.073 50 100.073V100.073C22.3858 100.073 0 77.6867 0 50.0725V50.0725Z"
                  fill="#D09A12"
                />
                <path
                  d="M48.8857 52.3011L44.4286 55.6439V42.6439H55.5714V55.6439L51.1143 52.3011C50.7928 52.06 50.4018 51.9297 50 51.9297C49.5982 51.9297 49.2072 52.06 48.8857 52.3011ZM55.1071 38.9297L51.8571 24.4811C51.8478 24.3451 51.8478 24.2086 51.8571 24.0725H46.2857C46.2857 24.0725 46.2857 24.2025 46.2857 24.2768L44.6514 38.9297H55.1071ZM75.2943 38.9297L69.4071 27.1554C68.9439 26.2275 68.2308 25.4473 67.3482 24.9026C66.4656 24.358 65.4485 24.0705 64.4114 24.0725H55.5714L58.8771 38.9297H75.2943ZM42.5714 24.0725H35.5886C34.5515 24.0705 33.5343 24.358 32.6518 24.9026C31.7692 25.4473 31.0561 26.2275 30.5929 27.1554L24.7057 38.9297H40.9186L42.5714 24.0725ZM76 42.6439V70.5011C76 71.9787 75.413 73.3958 74.3682 74.4407C73.3233 75.4855 71.9062 76.0725 70.4286 76.0725H29.5714C28.0938 76.0725 26.6767 75.4855 25.6318 74.4407C24.587 73.3958 24 71.9787 24 70.5011V42.6439H40.7143V59.3582C40.7153 59.7012 40.8113 60.0371 40.9916 60.3289C41.1719 60.6206 41.4294 60.8568 41.7357 61.0111C42.0325 61.1494 42.3606 61.2068 42.6868 61.1775C43.0129 61.1481 43.3255 61.0331 43.5929 60.8439L50 56.1082L56.3143 60.8439C56.6357 61.085 57.0267 61.2154 57.4286 61.2154C57.7201 61.2205 58.008 61.1501 58.2643 61.0111C58.5706 60.8568 58.8281 60.6206 59.0084 60.3289C59.1887 60.0371 59.2847 59.7012 59.2857 59.3582V42.6439H76ZM68.5714 66.7868C68.5714 66.2943 68.3758 65.8219 68.0275 65.4736C67.6792 65.1253 67.2068 64.9297 66.7143 64.9297H59.2857C58.7932 64.9297 58.3208 65.1253 57.9725 65.4736C57.6242 65.8219 57.4286 66.2943 57.4286 66.7868C57.4286 67.2793 57.6242 67.7517 57.9725 68.1C58.3208 68.4483 58.7932 68.6439 59.2857 68.6439H66.7143C67.2068 68.6439 67.6792 68.4483 68.0275 68.1C68.3758 67.7517 68.5714 67.2793 68.5714 66.7868Z"
                  fill="white"
                />
              </svg>
              <div class="text__block">
                <div class="text__block-head">Souscription</div>
                <div class="text__block-desc">
                  Faites le choix de votre produit d'assurance
                </div>
              </div>
            </div>
          </div>
          <div class="work__bloc--item">
            <div class="work__bloc--item_icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 50.0725C0 22.4583 22.3858 0.0725098 50 0.0725098V0.0725098C77.6142 0.0725098 100 22.4583 100 50.0725V50.0725C100 77.6867 77.6142 100.073 50 100.073V100.073C22.3858 100.073 0 77.6867 0 50.0725V50.0725Z"
                  fill="#D09A12"
                />
                <path
                  d="M76 73.8516V26.2935C76 25.7044 75.766 25.1395 75.3495 24.723C74.933 24.3065 74.3681 24.0725 73.779 24.0725H26.221C25.6319 24.0725 25.067 24.3065 24.6505 24.723C24.234 25.1395 24 25.7044 24 26.2935V73.8516C24 74.4406 24.234 75.0055 24.6505 75.422C25.067 75.8385 25.6319 76.0725 26.221 76.0725H73.779C74.3681 76.0725 74.933 75.8385 75.3495 75.422C75.766 75.0055 76 74.4406 76 73.8516ZM71.5581 47.8515H52.221V28.5144H71.5581V47.8515ZM47.779 28.5144V47.8515H28.4419V28.5144H47.779ZM28.4419 52.2935H47.779V71.6306H28.4419V52.2935ZM52.221 71.6306V52.2935H71.5581V71.6306H52.221Z"
                  fill="white"
                />
                <path
                  d="M56.1002 41.5811H59.824V45.3049H64.2659V41.5811H67.9897V37.1391H64.2659V33.4153H59.824V37.1391H56.1002V41.5811Z"
                  fill="white"
                />
                <path
                  d="M67.9897 59.3487H56.1002V63.7906H67.9897V59.3487Z"
                  fill="white"
                />
                <path
                  d="M44.4402 32.9785H32.5507V37.4204H44.4402V32.9785Z"
                  fill="white"
                />
                <path
                  d="M44.4402 39.5156H32.5507V43.9575H44.4402V39.5156Z"
                  fill="white"
                />
                <path
                  d="M44.2699 58.9341L41.131 55.7952L38.4954 58.4233L35.8599 55.7952L32.7209 58.9341L35.3565 61.5697L32.7209 64.1978L35.8599 67.3367L38.4954 64.7086L41.131 67.3367L44.2699 64.1978L41.6344 61.5697L44.2699 58.9341Z"
                  fill="white"
                />
              </svg>
              <div class="text__block">
                <div class="text__block-head">Police d’asurance</div>
                <div class="text__block-desc">
                  Obtenez le meilleur prix possible avec nous
                </div>
              </div>
            </div>
          </div>
          <div class="work__bloc--item">
            <div class="work__bloc--item_icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 50.0725C0 22.4583 22.3858 0.0725098 50 0.0725098V0.0725098C77.6142 0.0725098 100 22.4583 100 50.0725V50.0725C100 77.6867 77.6142 100.073 50 100.073V100.073C22.3858 100.073 0 77.6867 0 50.0725V50.0725Z"
                  fill="#D09A12"
                />
                <path
                  d="M28.6429 53.073H24.9286C24.416 53.073 24 52.657 24 52.1445V35.43C24 34.9175 24.416 34.5015 24.9286 34.5015H28.6429C29.1555 34.5015 29.5715 34.9175 29.5715 35.43V52.1445C29.5715 52.657 29.1555 53.073 28.6429 53.073Z"
                  fill="white"
                />
                <path
                  d="M51.8574 51.2159H32.3572V35.838C35.3652 34.1641 45.0212 28.93 48.1437 28.93C49.1812 28.93 50.6484 29.627 51.7763 30.2603L44.3514 40.8647C43.489 42.096 44.3693 43.7873 45.8724 43.7873H51.6587C53.509 43.7873 55.2238 45.0514 55.5209 46.8776C55.8992 49.2052 54.1132 51.2159 51.8574 51.2159Z"
                  fill="white"
                />
                <path
                  d="M75.8321 40.562L53.5772 72.3448C53.2831 72.7651 52.7043 72.8667 52.284 72.5726L35.1052 60.545C34.6849 60.251 34.5828 59.6722 34.8774 59.2518L38.5534 54.0023H43.0879L41.6331 56.0798C43.286 57.2232 43.7738 59.4827 42.5462 61.221L49.1082 65.8157C50.2541 64.1622 52.5149 63.6787 54.2513 64.9081L69.072 43.7415C67.4235 42.5975 66.9338 40.3379 68.1676 38.5978L61.6013 33.9988C60.4579 35.6492 58.1978 36.1376 56.4582 34.9063L52.1905 41.0015H47.6559L57.1318 27.4684C57.4258 27.0481 58.0046 26.9466 58.425 27.2406L75.6037 39.2688C76.024 39.5629 76.1262 40.1417 75.8321 40.562Z"
                  fill="white"
                />
              </svg>
              <div class="text__block">
                <div class="text__block-head">Paiement</div>
                <div class="text__block-desc">
                  Payer pour terminer votre souscription
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="page__store">
        <div class="page__store-text">
          <p class="font-24">NSIA Assurances Mobile</p>
          <p class="page-desc">
            Bientôt, souscrivez à votre assurance via l'application mobile de
            NSIA
          </p>
          <p>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.insurances.nsia"
            >
              <img src="images/playstore.png" alt="" />
            </a>
          </p>
        </div>
        <div class="page__store-img">
          <img width="455" src="images/app.png" alt="" />
        </div>
      </div>

      <div class="payment__info">
        <div class="payment__info--text">Moyens de paiement acceptés</div>
        <div class="payment__widget">
          <img src="images/payment.png" width="140" alt="payment" />
        </div>
      </div>

      <div class="voyage__info">
        <div
          class="happy__young"
          style="
            background: url(images/young.png) no-repeat center;
            background-size: cover;
          "
        ></div>
        <div class="hire__me">
          <div class="background__info">
            <div class="svg__hire">
              <svg
                width="188"
                height="188"
                viewBox="0 0 188 188"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z"
                  fill="#E8EFFF"
                />
              </svg>
            </div>
            <div class="hire__me--text">Contactez-nous</div>
            <div class="hire__me--description">
              Si vous avez des questions ou rencontrez une difficulté,
              contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
            </div>
            <div class="hire__me--button">
              <button class="btn btn-secondary">Parler à un expert</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "../../components/draggrable/index";
export default {
  name: "index",
  data: () => ({}),
};
</script>

<style scoped>
</style>
